import { render, staticRenderFns } from "./supplier-information.vue?vue&type=template&id=42b770e0&"
import script from "./supplier-information.vue?vue&type=script&lang=ts&"
export * from "./supplier-information.vue?vue&type=script&lang=ts&"
import style0 from "./supplier-information.vue?vue&type=style&index=0&id=42b770e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports